// Hook to upsert the tenantProviderAuth

/*  Shared  */
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useCallback, useRef, useState } from 'react';

interface TenantProviderAuth {
    authData: {
        [key: string]: string;
    };
    platformTenantId: string;
    providerType: string;
}

export const useCreateTenantProviderAuthAsync = () => {
    const [saving, setSaving] = useState(false);
    const error = useRef(null);
    const success = useRef(false);

    const createTenantProviderAuth = useCallback(
        async (providerAuth: TenantProviderAuth) => {
            try {
                setSaving(true);
                await axios.post('/tenantProviderAuth', {
                    ...providerAuth,
                    upsert: true
                });
                success.current = true;
            } catch (err) {
                debug.e('Error creating tenant provider.', err);
            }
            setSaving(false);
            return {
                error: error.current,
                success: success.current
            };
        },
        []
    );

    return { createTenantProviderAuth, saving };
};
